module.exports = __webpack_public_path__ + "img/logo-1.8382c5eb.png";